import React from "react";
import { TablePage } from "~/components/Table";
import { LogFilters } from "./components/LogFilters";
import { LogSearchRequestProvider, LogTable } from "./components/LogTable";

export function LogsPage() {
  return (
    <TablePage
      title="Search Logs"
      RequestProvider={LogSearchRequestProvider}
      table={<LogTable />}
      filters={<LogFilters />}
    />
  );
}
